<template>
  <div class="panel">
    <div
      class="head"
      >
      <div class="title">
        原稿一覧
        <Button
          @click="reloadSubject"
          style="font-size: 12px; font-weight: bold;"
          type="text"
          size="small">
          <Icon type="md-refresh"></Icon>
          更新
        </Button>
      </div>
      <div class="option">
        <Poptip trigger="hover" :content="subjectQuerySummary" word-wrap>
          <Button
            @click="setSubjectQueryModalTarget"
            ghost
            type="primary"
            size="small">
            <Icon type="md-search"></Icon>
            <template v-if="query.keyword">
              キーワード: "{{ query.keyword }}"
            </template>
            <template v-if="query.prefs.length > 0">
              地域: 指定あり
            </template>
            <template v-if="query.kinds.length > 0">
              種類: 指定あり
            </template>
            <template v-if="!query.keyword && query.prefs.length == 0 && query.kinds.length == 0">
            検索条件を設定
            </template>
          </Button>
        </Poptip>
      </div>
    </div>
    <div class="container">
      <Scroll
        :on-reach-bottom="paginateSubject"
        :distance-to-edge="-80"
        loading-text="読み込み中..."
        >
        <SubjectItem
          v-for="subject in subjects"
          :key="subject.id"
          :subject="subject"
          />
      </Scroll>
    </div>
    <FixedJournalAcceptModal />
  </div>
</template>

<script>
import { mapState, mapGetters, mapActions } from 'vuex'

import SubjectItem from './SubjectItem.vue'
import FixedJournalAcceptModal from '../../components/fixedJournals/FixedJournalAcceptModal.vue'

export default {
  components: {
    SubjectItem,
    FixedJournalAcceptModal,
  },
  computed: {
    ...mapGetters([
      'listSubject'
    ]),
    ...mapGetters({
      query: 'dashboard/subjectQuery'
    }),
    subjects() {
      return this.listSubject({
        prefs: this.query.prefs,
        kinds: Object.values(this.query.kinds).flat().filter(i => i),
        ...this.$route.params
      })
    },
    subjectQuerySummary() {
      return this.query.prefs.length > 0 ? this.query.prefs.join(",") : "なし"
    }
  },
  methods: {
    ...mapActions({
      setSubjectQueryModalTarget: 'dashboard/setSubjectQueryModalTarget',
      loadSubject: 'dashboard/loadSubject',
      unloadSubject: 'dashboard/unloadSubject',
    }),
    async paginateSubject(dir) {
      return new Promise(resolve => {
        setTimeout(() => {
          this.loadSubject(this.$route.params).then(() => {
            resolve();
          });
        }, 1000);
      });
    },
    async reloadSubject() {
      await this.unloadSubject()
      await this.loadSubject(this.$route.params)
    }
  }
}
</script>

<style lang="less" scoped>
.panel {
  position: relative;
  height: 100%;
  min-width: 360px;
  background: white;

  .container {
    padding: 40px 0px 0px;
    height: 100%;
    overflow: hidden;

  }

  .head {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 40px;
    padding: 8px 8px;
    box-shadow: 0 5px 2px 0 #dddee1;
    background: white;
    z-index: 10;
    user-select: none;

    .title {
       float: left;
       font-size: 16px;
       font-weight: bold;
       padding: 0 8px;
    }

    .option {
       float: right;
       max-width: 65%;
       white-space: nowrap;
       font-size: 12px;

       button {
          padding: 0 20px;
          font-weight: bold;
          font-size: 12px;

          i {
            padding: 0 0 2px;
            vertical-align: middle;
          }
       }
    }

    code {
      display: inline-block;
      background: #f7f7f7;
      margin: 0 3px;
      padding: 1px 5px;
      font-size: 10px;
      border-radius: 3px;
      color: #666;
      border: 1px solid #eee;
    }
  }
}
</style>

<style lang="less">
.panel .container {
  .ivu-scroll-wrapper {
    height: 100% !important;
  }
  
  .ivu-scroll-container {
    height: 100% !important;
  }
}

.query {
  .ivu-collapse {
    border: 0 !important;
  }
  .ivu-collapse-item {
    border-top: 0;
  }
  .ivu-collapse-header {
     padding-left: 0;
  }
}
</style>
